import moment from 'moment';

export function formatDateTime(dateString) {
  return moment(dateString).format('lll');
}

export function formatDate(dateString) {
  return moment(dateString).format('DD/MM/YYYY');
}
